const emailUrl = {url:'https://www.museumofphilately.com/mailer/email.php'}
export default emailUrl
